module.exports = __webpack_public_path__ + "img/0-sm.54a1dcd8.jpg";